import { CoeDataAnalysisEntityModel } from "src/store/models/entity/coeDataAnalysis/entity";
import { CoeDataAnalysisHelperModel } from "src/store/models/entity/coeDataAnalysis/helper";

export const encooCoeDataAnalysisModels = {
  entity: CoeDataAnalysisEntityModel,
  helper: CoeDataAnalysisHelperModel,
};
